import SelectInput from 'components/atoms/form/SelectInput/SelectInput'
import TextAreaInput from 'components/atoms/form/TextAreaInput/TextAreaInput'
import * as RoleConfigurationConst from 'constants/RoleConfigurationConst'
import StringConst from 'constants/StringConst'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import CommentsService from 'services/CommentsService'
import { isArrayIncludesAny, isArrayNotEmpty, isObjectEmpty } from 'utilities/JSUtil'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import { getSessionItem, setSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Feedback.scss'

class Feedback extends Component {

    constructor(props) {
        super(props)
        let hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        let hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        let onboardingStatus = getSessionItem(SessionConst.ONBOARDING_STATUS)
        let user = getSessionItem(SessionConst.USER)

        const isAdmin = user.isAdmin
        const jobRoles = user.jobRoles
        const rolesAllowedToReviewComplete = [RoleConfigurationConst.AREA_DIRECTOR_ROLE, RoleConfigurationConst.REVENUE_MANAGER_ROLE]
        const isAbleToReviewComplete = isArrayIncludesAny(jobRoles, rolesAllowedToReviewComplete) && onboardingStatus.status === FormConst.STATUS_UNDER_REVIEW
        const hideEmailAddresses = isArrayIncludesAny(jobRoles, RoleConfigurationConst.HOTEL_CONTACT_ROLES)

        //turn off readOnly flag for the user if flag isAbleToReviewComplete == true
        if (isAbleToReviewComplete) {
            setSessionItem(SessionConst.IS_READ_ONLY, FormConst.VALUE_NO)
        }

        const isReadOnly = getSessionItem(SessionConst.IS_READ_ONLY) === FormConst.VALUE_NO ? false : true

        if (!(hotelCode || hotelInfo || onboardingStatus || onboardingStatus.hotelOnboardingId || user)) {
            // Go home
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }
        const isHotelContact = user.isHotelContact
        const overrideDisabledFlag = onboardingStatus.status === FormConst.STATUS_COMPLETED ? 'true' : 'false'

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            onboardingStatus: onboardingStatus,
            user: user,
            isHotelContact: isHotelContact,
            isReadOnly: isReadOnly,
            isAdmin: isAdmin,
            isAbleToReviewComplete: isAbleToReviewComplete,
            hideEmailAddresses: hideEmailAddresses,
            isUpdateStatus: false,
            initialValues: {
                feedback: '',
                feedbackHistory: [],
                stateInError: onboardingStatus.stateInError,
                status: onboardingStatus.status
            },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            showResetModal: false,
            showErrorModal: false,
            statusOptions: this.getStatusOptions(onboardingStatus.status, isAbleToReviewComplete),
            showRedirectModal: false,
            overrideDisabledFlag: overrideDisabledFlag
        }
    }

    validationSchema = Yup.object().shape({
        feedback: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED)
            .matches(FormConst.FEEDBACK_PATTERN, FormConst.VALIDATION_ERROR_SPECIAL_CHARACTERS)
    })

    async componentDidMount() {
        await CommentsService.getComments({ hotelCode: this.state.hotelCode })
            .then(response => {
                let feedbackHistory = []
                if (isArrayNotEmpty(response.comments)) {
                    for (let index = response.comments.length - 1; index >= 0; index--) {
                        feedbackHistory.push(response.comments[index])
                    }
                }
                this.setState({
                    isLoading: false,
                    initialValues: {
                        ...this.state.initialValues,
                        feedbackHistory: feedbackHistory
                    }
                })
            }).catch(error => {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: 'There was an error while retrieving Feedback History'
                })
            })
    }
    //Adding this method to set back the flag is read only in case it was modified
    componentWillUnmount() {
        if(this.state.isAbleToReviewComplete){
            setSessionItem(SessionConst.IS_READ_ONLY,FormConst.VALUE_YES )
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({ isLoading: false, showErrorModal: true, errorMessage: this.props.errorDescription })
            } else {
                if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.PUT_COMMENTS) {
                    if (this.state.isUpdateOnboardingStatus) {
                        this.props.onPutStatus({ hotelOnboardingId: this.state.onboardingStatus.hotelOnboardingId, formData: this.state.pendingOnboardingStatus })
                        this.setState({
                            isLoading: true,
                            initialValues: {
                                ...this.state.initialValues,
                                feedbackHistory: [...this.state.pendingFeedback, ...this.state.initialValues.feedbackHistory],
                                feedback: ''
                            },
                            pendingFeedback: undefined,
                        })
                    } else {
                        this.setState({
                            isLoading: false,
                            initialValues: {
                                ...this.state.initialValues,
                                feedbackHistory: [...this.state.pendingFeedback, ...this.state.initialValues.feedbackHistory],
                                feedback: ''
                            },
                            pendingFeedback: undefined
                        })
                    }
                } else {
                    if (this.state.isStatusChange) {
                        this.setState({
                            isLoading: false, showRedirectModal: true, showErrorModal: false
                        })
                    } else {
                        setSessionItem(SessionConst.ONBOARDING_STATUS, this.state.pendingOnboardingStatus)
                        this.setState({
                            isLoading: false,
                            initialValues: {
                                ...this.state.initialValues,
                                stateInError: this.state.pendingStateInError
                            },
                            onboardingStatus: this.state.pendingOnboardingStatus,
                            pendingOnboardingStatus: undefined,
                            pendingStateInError: undefined,
                        })
                    }
                }
            }
        }
    }

    handleSubmit = (data, stateInError) => {
        if (data.stateInError !== stateInError) {
            // Report or resolve issue
            // Update comments and stateInError
            let comments = []

            if (data.stateInError) {
                comments.push(data.feedback)
                comments.push(FormConst.FEEDBACK_RESOLVE_ISSUE)
            } else {
                comments.push(FormConst.FEEDBACK_REPORT_ISSUE)
                comments.push(data.feedback)
            }

            let onboardingStatus = {
                ...this.state.onboardingStatus,
                stateInError: stateInError,
                checklist: undefined
            }

            comments = comments.map(comment => { return { text: comment, createdBy: this.state.user.username } })

            this.props.onPutComments({ hotelCode: this.state.hotelCode, comments: comments })
            this.setState({ isLoading: true, isUpdateOnboardingStatus: true, isStatusChange: false, pendingStateInError: stateInError, pendingFeedback: [...comments].reverse(), pendingOnboardingStatus: onboardingStatus })
        } else {
            let comments = []
            let onboardingStatus
            let isStatusChange = false
            if (data.status === this.state.onboardingStatus.status) {
                // Update comments
                comments.push(data.feedback)
            } else {
                // Update comments and status
                comments.push(data.feedback)
                comments.push(FormConst.getUpdateStatusFeedback(this.state.onboardingStatus.status, data.status))

                onboardingStatus = {
                    ...this.state.onboardingStatus,
                    status: data.status,
                    checklist: undefined
                }
                isStatusChange = true
            }
            comments = comments.map(comment => { return { text: comment, createdBy: this.state.user.username } })
            this.props.onPutComments({ hotelCode: this.state.hotelCode, comments: comments })
            this.setState({ isLoading: true, isUpdateOnboardingStatus: !!onboardingStatus, isStatusChange: isStatusChange, pendingFeedback: [...comments].reverse(), pendingStateInError: stateInError, pendingOnboardingStatus: onboardingStatus })
        }
    }

    getStatusOptions = (onboardingStatus, isAbleToReviewComplete) => {
        switch (onboardingStatus) {
            case FormConst.STATUS_IN_PROGRESS:
                return [
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus }
                    // { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }
                ]
            case FormConst.STATUS_UNDER_REVIEW:
                if(isAbleToReviewComplete){
                    return [
                        { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus },
						{ label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_IN_PROGRESS], value: FormConst.STATUS_IN_PROGRESS },
                        { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_REVIEW_COMPLETE], value: FormConst.STATUS_REVIEW_COMPLETE }
                    ]
                }
                return [
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus },
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_IN_PROGRESS], value: FormConst.STATUS_IN_PROGRESS },
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_REVIEW_COMPLETE], value: FormConst.STATUS_REVIEW_COMPLETE }
                    // { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }
                ]
            case FormConst.STATUS_REVIEW_COMPLETE:
                if(isAbleToReviewComplete){
                    return [
                        { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus },
                        { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_IN_PROGRESS], value: FormConst.STATUS_IN_PROGRESS }
                    ]
                }
                return [
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus },
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_IN_PROGRESS], value: FormConst.STATUS_IN_PROGRESS },
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_COMPLETED], value: FormConst.STATUS_COMPLETED }
                    // { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }
                ]
            case FormConst.STATUS_COMPLETED:
                return [
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus }
                ]
            case FormConst.STATUS_CLOSED:
                return [{ label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }]
            case FormConst.STATUS_LOAD_ERROR:
                return [{ label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus },
                { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_IN_PROGRESS], value: FormConst.STATUS_IN_PROGRESS }
                // { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }
                ]
            default:
                return [
                    { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[onboardingStatus], value: onboardingStatus }
                    // { label: FormConst.HOTEL_ONBOARDING_STATUS_TO_DISPLAY_STATUS[FormConst.STATUS_CLOSED], value: FormConst.STATUS_CLOSED }
                ]
        }
    }

    render() {
        return (
            <div id='feedback-form' className='feedback-form'>
                <Formik
                    initialValues={this.state.initialValues}
                    validationSchema={this.validationSchema}
                    enableReinitialize={true}
                    onSubmit={(data, { setSubmitting, resetForm }) => {
                        setSubmitting(true)
                        this.handleSubmit(data)
                        setSubmitting(false)
                    }}>
                    {
                        ({ values, errors, touched, dirty, isSubmitting, handleChange, resetForm }) => (
                            <Form className='feedback-form-element'>
                                <div id='feedback-form-fields' className='feedback-form-fields'>


                                    {
                                        this.props.onboardingStatus !== FormConst.STATUS_COMPLETED
                                            ? (<>
                                                <p className='helper-text'>
                                                    {
                                                        this.state.isHotelContact
                                                            ? FormConst.FEEDBACK_HELPER_TEXT_HOTEL_CONTACT
                                                            : ((this.state.isAdmin || this.state.isAbleToReviewComplete)
                                                                ? (values.stateInError ? FormConst.FEEDBACK_HELPER_TEXT_ADMIN : FormConst.FEEDBACK_HELPER_TEXT_ADMIN_STATUS_CHANGE)
                                                                : FormConst.FEEDBACK_HELPER_TEXT_DEFAULT)
                                                    }
                                                </p>
                                                <TextAreaInput
                                                    id='feedback-text'
                                                    name='feedback'
                                                    rows={10}
                                                    maxLength={FormConst.FEEDBACK_MAXIMUM_LENGTH}
                                                    overridedisabledflag={(this.state.isAdmin || this.state.isAbleToReviewComplete) ? this.state.overrideDisabledFlag : 'false'} />
                                                <p className='float-right'>Characters left: {FormConst.FEEDBACK_MAXIMUM_LENGTH - values.feedback.length}</p>

                                                {
                                                    (this.state.isAdmin || this.state.isAbleToReviewComplete)
                                                        ? (
                                                            values.stateInError
                                                                ? (
                                                                    <div className='update-feedback-actions'>
                                                                        {/* <p>Resolve the error to update application state</p> */}
                                                                        <Button
                                                                            id='resolve-issue'
                                                                            name='Resolve'
                                                                            disabled={isSubmitting || !values.feedback || !isObjectEmpty(errors)}
                                                                            className='resolve'
                                                                            onClick={() => { this.handleSubmit(values, false) }}
                                                                            overridedisabledflag={this.state.overrideDisabledFlag} />
                                                                        <Button
                                                                            id='save-feedback'
                                                                            className='save'
                                                                            name='Save'
                                                                            disabled={isSubmitting || !values.feedback || !isObjectEmpty(errors)}
                                                                            onClick={() => { this.handleSubmit(values, values.stateInError) }}
                                                                            overridedisabledflag={this.state.overrideDisabledFlag} />
                                                                        <Button
                                                                            id='return-to-form'
                                                                            className='return-to-form'
                                                                            name='Go back to Form'
                                                                            onClick={() => { this.props.history.goBack() }} />
                                                                    </div>
                                                                )
                                                                : (
                                                                    <div className='update-status-action'>
                                                                        {
                                                                            this.state.statusOptions
                                                                            && <SelectInput
                                                                                id='application-status'
                                                                                name='status'
                                                                                label='Application Status'
                                                                                options={this.state.statusOptions}
                                                                                overridedisabledflag={this.state.overrideDisabledFlag} />
                                                                        }
                                                                        <Button
                                                                            id='update-status'
                                                                            name='Submit'
                                                                            disabled={isSubmitting || !values.feedback || !isObjectEmpty(errors)}
                                                                            className='submit'
                                                                            onClick={() => { this.handleSubmit(values, false) }}
                                                                            overridedisabledflag={this.state.overrideDisabledFlag} />
                                                                        <Button
                                                                            id='return-to-form'
                                                                            className='return-to-form'
                                                                            name='Go back to Form'
                                                                            onClick={() => { this.props.history.goBack() }} />
                                                                    </div>
                                                                )
                                                        )
                                                        : (
                                                            <div className='update-feedback-action'>
                                                                <Button
                                                                    id='submit-feedback'
                                                                    name='Submit'
                                                                    className='submit'
                                                                    onClick={() => { this.handleSubmit(values, true) }}
                                                                    disabled={isSubmitting || !values.feedback || !isObjectEmpty(errors)} />
                                                                <Button
                                                                    id='return-to-form'
                                                                    className='return-to-form'
                                                                    name='Go back to Form'
                                                                    onClick={() => { this.props.history.goBack() }} />
                                                            </div>
                                                        )
                                                }

                                            </>
                                            ) : (
                                                <></>
                                            )
                                    }
                                    <table className='table table-bordered feedback-history-table'>
                                        <thead>
                                            <tr>
                                                <th>Feedback History</th>
                                            </tr>
                                        </thead>
                                        {
                                            isArrayNotEmpty(values.feedbackHistory)
                                                ? (
                                                    <tbody>
                                                        {values.feedbackHistory.map((feedbackEntry, feedbackEntryIndex) => {
                                                            let createdTimestamp = feedbackEntry.createdAt?.split('T');
                                                            let createdDate = undefined
                                                            let createdTime = undefined
                                                            let rowClasses
                                                            if (isArrayNotEmpty(createdTimestamp)) {
                                                                createdDate = createdTimestamp[0]
                                                                createdTime = createdTimestamp[1]
                                                            } else {
                                                                rowClasses = 'current-feedback'
                                                                createdTime = 'now'
                                                            }
                                                            return <tr key={feedbackEntryIndex} className={rowClasses}>
                                                                <td>
                                                                    <span className='text-blue text-normal'>{createdDate} {createdTime} {this.state.hideEmailAddresses ? FormConst.VALUE_EMPTY : feedbackEntry.createdBy}:</span>
                                                                    {StringConst.NBSP}
                                                                    <span className='text-normal'>
                                                                        {feedbackEntry.text}
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        })}
                                                    </tbody>
                                                )
                                                : (
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan="2">No feedback history</td>
                                                        </tr>
                                                    </tbody>
                                                )
                                        }
                                    </table>
                                </div>
                                <FormModal
                                    id='feedback-page-save-modal'
                                    title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                    hotelInfo={this.state.hotelInfo}
                                    body={<h6>{this.state.loadingMessage}</h6>}
                                    show={this.state.isLoading}
                                    isLoadingIndicator />
                                <FormModal
                                    id='feedback-page-redirect-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={'Status updated'}
                                    body={<h5>{'Application status modified. Please reopen the application for updated state.'}</h5>}
                                    proceed={() => this.props.history.push(RouteConst.ROUTE_HOME_PAGE)}
                                    proceedName='Home Page'
                                    show={this.state.showRedirectModal} />
                                <FormModal
                                    id='feedback-page-error-modal'
                                    hotelInfo={this.state.hotelInfo}
                                    title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                    body={<h5>{this.state.errorMessage}</h5>}
                                    isError
                                    cancel={() => { this.setState({ showErrorModal: false }) }}
                                    show={this.state.showErrorModal} />
                            </Form>
                        )
                    }
                </Formik>
            </div>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        onboardingStatusResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onPutStatus: (data) => dispatch(asyncMethod(FormConst.FORM_FEEDBACK_NAME, actionTypes.ASYNC_ACTIONS.PUT_ONBOARDING_STATUS, data)),
        onPutComments: (data) => dispatch(asyncMethod(FormConst.FORM_FEEDBACK_NAME, actionTypes.ASYNC_ACTIONS.PUT_COMMENTS, data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withFormLayout(Feedback, SideNavEntryMapping.FEEDBACK)))
